import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { allCategories } from "@/lib/articles";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <h1 className="font-heading text-7xl font-black text-primary-500 md:text-9xl">404</h1>
        <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          页面走丢了
        </h2>
        <p className="mt-2 text-sm text-foreground-500">你访问的地址不存在：{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm text-foreground-600">
          别着急，试试下面的入口，或返回首页继续浏览鲁啊鲁的内容。
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="rounded-full border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            去搜索内容
          </Link>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {allCategories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="rounded-full bg-background-100 px-4 py-1.5 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors"
            >
              {category.name}频道
            </Link>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}